import { selectPeriod } from 'modules/overlay-v2/store/time/selectors';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import UDText from 'ud-ui/components/text';
import { DivProps } from 'typings';
import useGameInfo from 'modules/overlay-v2/ui/hooks/use-game-info';
import Fouls from './fouls';
import PlayersList from './players-list';
import Score from './score';
import { PanelItemWrapper } from './styles';
import { theme } from 'styles/theme/theme';

interface IProps extends DivProps {
  teamIndex: number;
}

function TeamPanel(props: IProps) {
  const { teamIndex, ...rest } = props;

  const { teams } = useGameInfo();
  const period = useSelector(selectPeriod);

  const team = useMemo(() => {
    if (teamIndex === 0) return teams?.first;
    if (teamIndex === 1) return teams?.second;
  }, [teamIndex, teams]);

  return (
    <PanelItemWrapper {...rest}>
      <div className={'flex-center w-full'}>
        <UDText type={'headline'} color={theme.colors.Gray}>
          {team?.name ?? 'Неизвестная команда'}
        </UDText>
      </div>

      <div className={'flex flex-row flex-wrap gap-8'}>
        <div className={'flex grow flex-col'}>
          <Score className={'mt-2'} teamIndex={teamIndex} />
          <Fouls className={'mt-2'} teamIndex={teamIndex} period={period} />
        </div>
        <div>
          <PlayersList teamIndex={teamIndex} />
        </div>
      </div>
    </PanelItemWrapper>
  );
}

export default TeamPanel;
